import React from 'react';
import ReactDOM from 'react-dom/client'; 
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';

import './styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root')); 
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);